import React from 'react'
import styles from './styles.module.css'

/*
 * Shared CTA loading spinner (Phase 3.5 finish, #89). Replaces the former
 * styled-components `Loading` div that both CtaLoading and CtaV2 imported from
 * ./elements. The `dark` boolean swaps the ring color/width exactly as before.
 */
const Loading = ({ dark }) => (
  <div className={dark ? `${styles.loading} ${styles.loadingDark}` : styles.loading} />
)

export default Loading
